module.exports = __webpack_public_path__ + "static/media/abous-us-image.53483c50.jpg";